import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { useCallback, useEffect, useState } from "react";
import * as yup from "yup";
import useInvoicePaymentModalSummary from "./useInvoicePaymentModalSummary";
import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useFormikContext } from "formik";
import { invPaymentInit } from "utils/HelperInvoicePayment";
import { useFormHandler } from "hooks/useFormHandler";
import cloneDeep from "lodash/cloneDeep";
export default function useInvoicePaymentModal() {
    var schema = yup.object().shape({
        factNewInvAdjustmentOrFee: yup.array().of(yup.object({
            dim_mst_adjust_or_fee_id: yup.string().required("จำเป็นต้องเลือกประเภทค่าปรับ/ค่าธรรมเนียม")
        })),
        factNewInvPaymentRow: yup.array().of(yup.object({
            dim_branch_payment_channel_id: yup.string().required("จำเป็นต้องเลือกประเภทค่าปรับ/ค่าธรรมเนียม")
        }))
    });
    var _useState = _sliced_to_array(useState(invPaymentInit), 2), form = _useState[0], setForm = _useState[1];
    var _useState1 = _sliced_to_array(useState({}), 2), errors = _useState1[0], setErrors = _useState1[1];
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, setFieldValue = _useFormikContext.setFieldValue;
    var modalInvoiceModalState = useInvoiceInitContext().modalInvoiceModalState;
    var modalInvPayment = modalInvoiceModalState.modalInvPayment, setModalInvPayment = modalInvoiceModalState.setModalInvPayment;
    var _useInvoicePaymentModalSummary = useInvoicePaymentModalSummary({
        payment: form
    }), sumPaymentInModal = _useInvoicePaymentModalSummary.sumPaymentInModal, sumRowsInModal = _useInvoicePaymentModalSummary.sumRowsInModal, sumAdjustmentsInModal = _useInvoicePaymentModalSummary.sumAdjustmentsInModal, totalToBePaidInModal = _useInvoicePaymentModalSummary.totalToBePaidInModal;
    var parseHeight = function(height) {
        if (!height) return 0;
        if (typeof height === "number") return height;
        if (typeof height === "string") {
            var match = height.match(/^(\d+)(px)?$/);
            if (match) return parseInt(match[1], 10);
        }
        return 0; // fallback
    };
    var handleRemove = function() {
        setForm(invPaymentInit);
    };
    var onCloseOrCancel = function() {
        handleRemove();
        setModalInvPayment(function(prev) {
            return _object_spread_props(_object_spread({}, prev), {
                open: false
            });
        });
    };
    var handleConfirm = function() {
        var _ref = _async_to_generator(function() {
            var updated, err, errorObject;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            schema.validate(form, {
                                abortEarly: false
                            })
                        ];
                    case 1:
                        _state.sent();
                        setErrors({});
                        updated = _to_consumable_array(values.factNewInvPayment);
                        if (modalInvPayment.modeInv === "create") {
                            updated.push(cloneDeep(form));
                        } else {
                            updated[modalInvPayment.paymentIndex] = cloneDeep(form);
                        }
                        setFieldValue("factNewInvPayment", updated);
                        setForm(invPaymentInit);
                        setModalInvPayment(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: false,
                                modeInv: null,
                                paymentIndex: null,
                                shouldInitForm: true
                            });
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        if (err.name === "ValidationError") {
                            errorObject = err.inner.reduce(function(acc, curr) {
                                acc[curr.path] = curr.message;
                                return acc;
                            }, {});
                            setErrors(errorObject);
                        } else {
                            console.error("Unexpected error in handleConfirm:", err);
                        }
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var formHandlerState = useFormHandler({
        form: form,
        setForm: setForm
    });
    useEffect(function() {
        if (modalInvPayment.open && modalInvPayment.shouldInitForm) {
            if (modalInvPayment.modeInv === "create") {
                setForm(invPaymentInit);
            } else {
                var _values_factNewInvPayment;
                var _modalInvPayment_paymentIndex;
                var index = (_modalInvPayment_paymentIndex = modalInvPayment.paymentIndex) !== null && _modalInvPayment_paymentIndex !== void 0 ? _modalInvPayment_paymentIndex : 0;
                var payment = (_values_factNewInvPayment = values.factNewInvPayment) === null || _values_factNewInvPayment === void 0 ? void 0 : _values_factNewInvPayment[index];
                setForm(payment ? cloneDeep(payment) : invPaymentInit); // ✅ deep clone
            }
        }
    }, [
        modalInvPayment,
        values.factNewInvPayment
    ]);
    return {
        schema: schema,
        form: form,
        setForm: setForm,
        errors: errors,
        parseHeight: parseHeight,
        handleConfirm: handleConfirm,
        onCloseOrCancel: onCloseOrCancel,
        totalToBePaidInModal: totalToBePaidInModal,
        sumPaymentInModal: sumPaymentInModal,
        sumRowsInModal: sumRowsInModal,
        sumAdjustmentsInModal: sumAdjustmentsInModal,
        formHandlerState: formHandlerState
    };
}
